import "./Aanmelden.scss"
import Key from "../../Assets/Icons/Key.svg"
import { useForm } from 'react-hook-form';
import { useLogin, useSession, useSuccesfullLogin, useFailedLogin } from '../../Contexts/Authprovider';
import { useNavigate  } from "react-router-dom";
import React  from 'react';
import { useState, useCallback, useEffect } from "react";
import { toast } from "react-toastify";
export default function Aanmelden(){
        const navigate = useNavigate();
        const { handleSubmit, register } = useForm();
        const login = useLogin();
        const succesfullLogin = useSuccesfullLogin();
        const failedLogin = useFailedLogin();
        const { isAuthed } = useSession();
        let [attempt, setAttempt] = useState(1);
        const [status, setStatus] = useState();
        useEffect(() => {
            if (status === 'locked'){
                document.getElementById('Login-Username').value ="";
                document.getElementById('Login-Password').value ="";
                document.getElementById('Login-Username').disabled = true;
                document.getElementById('Login-Password').disabled = true;
                document.getElementById('EID-Button').disabled = true;
                document.getElementById('key').disabled = true;
                document.getElementById('Login-Button').disabled = true;
            }
            else{
                document.getElementById('Login-Username').value ="";
                document.getElementById('Login-Password').value ="";
                document.getElementById('Login-Username').disabled = false;
                document.getElementById('Login-Password').disabled = false;
                document.getElementById('Login-Button').disabled = false;
                document.getElementById('EID-Button').disabled = false;
                document.getElementById('key').disabled = false;
                document.getElementById('Login-Username').style.borderColor = 'rgba(210, 210, 210, 0.5)';
                document.getElementById('Login-Password').style.borderColor = 'rgba(210, 210, 210, 0.5)';
                document.getElementById('wrong-credentials').style.display='none';
            }
        },[status])
        const handleLogin = useCallback(async({username,password})=>{
            const user = await login(username, password);
            if (user) {
                succesfullLogin(user);
                document.getElementsByClassName('Login-Box')[0].classList.add("animate")
                await timeout(500)
                navigate("/")
            }else{
                setAttempt(attempt + 1);
                document.getElementById('Login-Username').style.borderColor = 'red';
                document.getElementById('Login-Password').style.borderColor = 'red';
                document.getElementById('wrong-credentials').style.display='block';
                if(attempt === 3){
                    setStatus("locked");
                    setAttempt(1)
                    toast.error("3 failed attempt's. Try again in 30 seconds", {
                        position: "top-right",
                        autoClose: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: false,
                        closeButton: true,
                        });
                    failedLogin(username,null, attempt, status);
                    setTimeout(()=> {
                        setStatus("")
                        toast.info("U can try to login again", {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: false,
                            });
                    },30000)
                }
            }
        },[login, navigate, attempt,status,failedLogin, succesfullLogin]);
    
        useEffect(()=>{
            if (isAuthed) {
                return navigate('/');//redirect juist??
              }
        },[isAuthed, navigate])
    
        function timeout(delay) {
            return new Promise( res => setTimeout(res, delay) );
        }
    return (
            <div className="Login-Box">
                <p>Login</p>
                <form onSubmit={handleSubmit(handleLogin)}>
                <input id="Login-Username" className="Login-Input" type="text" placeholder="Username" name="Gebruikersnaam" required data-cy="login_gebruikersnaam" {...register('username')} ></input>
                <input id="Login-Password" className="Login-Input" type="password" placeholder="Password" name="Wachtwoord" required data-cy="login_wachtwoord" {...register('password')}></input>
                <p id="wrong-credentials" className="wrong-credentials" required data-cy="error-message" hidden>Combination of username and password is incorrect</p>
                    <button id="Login-Button" className="Login-Button" type="submit" required data-cy="login_button">Sign In</button>
                </form>

                <div className="Line-Container">
                    <span className="line"/>
                    <p>or</p>
                    <span className="line"/>
                </div>
                <button onClick={() => {navigate("/eid-login")}} id="EID-Button" type="submit" required data-cy="eid_button"><img id="key" src={Key} alt="key"/>Sign In with EID</button>
            </div>
    );
}